import React from 'react';
import { Modal, Form, Input, Select } from 'antd';
import type { AdminRole } from '../../types/adminInvitation';
import type { InviteAdminPayload } from '../../types/adminInvitation';

const ROLE_OPTIONS: { value: AdminRole; label: string }[] = [
  { value: 'super_admin', label: 'Super Admin' },
  { value: 'admin', label: 'Admin' },
  { value: 'support', label: 'Support' },
];

export interface InviteAdminModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (payload: InviteAdminPayload) => Promise<void>;
  loading?: boolean;
}

export const InviteAdminModal: React.FC<InviteAdminModalProps> = ({
  open,
  onClose,
  onSubmit,
  loading = false,
}) => {
  const [form] = Form.useForm<{ email: string; role: AdminRole }>();

  const handleOk = async () => {
    const values = await form.validateFields();
    await onSubmit({
      email: values.email,
      role: values.role,
    });
    form.resetFields();
    onClose();
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title="Mời Admin"
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={loading}
      destroyOnClose
      okText="Gửi lời mời"
      cancelText="Hủy"
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{ role: 'support' as AdminRole }}
      >
        <Form.Item
          name="email"
          label="Email"
          rules={[
            { required: true, message: 'Email is required' },
            { type: 'email', message: 'Enter a valid email address' },
          ]}
        >
          <Input placeholder="admin@example.com" autoComplete="email" />
        </Form.Item>

        <Form.Item
          name="role"
          label="Role"
          rules={[{ required: true, message: 'Role is required' }]}
        >
          <Select placeholder="Select role" options={ROLE_OPTIONS} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
